import { useEffect } from "react";

const SITE_NAME = "Tutors Melbourne";
// Canonicals must always point at the real site, never at a preview host
const SITE_URL = (process.env.REACT_APP_SITE_URL || "").replace(/\/$/, "");

/** Google truncates around 155-160 chars — clip on a word boundary. */
export const clipDescription = (text, max = 155) => {
  const clean = String(text || "").replace(/\s+/g, " ").trim();
  if (clean.length <= max) return clean;
  return `${clean.slice(0, max).replace(/[\s,;:.\-]+\S*$/, "")}…`;
};
const DEFAULT_IMAGE = "/logo.png";

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/** Per-route SEO: title, description, canonical, Open Graph/Twitter cards and optional JSON-LD. */
export const Seo = ({ title, description, path = "", image = DEFAULT_IMAGE, jsonLd, noindex = false, rawTitle = false }) => {
  useEffect(() => {
    const fullTitle = rawTitle && title ? title : title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Learning Perfected`;
    document.title = fullTitle;
    const origin = SITE_URL || window.location.origin;
    const url = `${origin}${path || window.location.pathname}`;

    setMeta("name", "description", clipDescription(description));
    setMeta("name", "robots", noindex ? "noindex,nofollow" : "index,follow");
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", url);
    setMeta("property", "og:site_name", SITE_NAME);
    setMeta("property", "og:image", image.startsWith("http") ? image : `${origin}${image}`);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);
    setLink("canonical", url);

    let script = document.getElementById("route-json-ld");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "route-json-ld";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
  }, [title, description, path, image, jsonLd, noindex, rawTitle]);

  return null;
};

export default Seo;
